(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const initializeMobileMenu = (root) => {
      if (!root || !root.querySelector) return;
      const menu = root.querySelector('[data-ga-mobile-menu]');
      const nav = root.querySelector('[data-ga-mobile-nav]');
      if (!menu || !nav || menu.dataset.gaMobileMenuReady === 'true') return;

      menu.dataset.gaMobileMenuReady = 'true';

      const closeMenu = () => {
        menu.setAttribute('aria-expanded', 'false');
        menu.setAttribute('aria-label', 'Open menu');
        nav.classList.remove('is-open');
      };

      const toggleMenu = () => {
        const isOpen = menu.getAttribute('aria-expanded') === 'true';
        menu.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        menu.setAttribute('aria-label', isOpen ? 'Open menu' : 'Close menu');
        nav.classList.toggle('is-open', !isOpen);
      };

      menu.addEventListener('click', toggleMenu);
      nav.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMenu));
      document.addEventListener('click', (event) => {
        if (!root.contains(event.target)) closeMenu();
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && menu.getAttribute('aria-expanded') === 'true') {
          closeMenu();
          menu.focus();
        }
      });
      window.addEventListener('resize', () => {
        if (window.innerWidth > 760) closeMenu();
      });
    };

    initializeMobileMenu(document.querySelector('.site-header'));
    document.addEventListener('shopify:section:load', (event) => {
      initializeMobileMenu(event.target.querySelector('.site-header') || event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (() => {
    const initializeCarousels = (root) => root.querySelectorAll('[data-ga-product-carousel]').forEach((carousel) => {
      if (carousel.dataset.gaCarouselReady === 'true') return;
      carousel.dataset.gaCarouselReady = 'true';
      const viewport = carousel.querySelector('[data-ga-carousel-viewport]');
      const track = carousel.querySelector('[data-ga-carousel-track]');
      const slides = Array.from(carousel.querySelectorAll('[data-ga-carousel-slide]'));
      const thumbnails = Array.from(carousel.querySelectorAll('[data-ga-carousel-thumbnail]'));
      const previous = carousel.querySelector('[data-ga-carousel-previous]');
      const next = carousel.querySelector('[data-ga-carousel-next]');

      if (!track || slides.length < 1) return;

      let activeIndex = 0;
      let scrollTimer;

      const setActive = (index, shouldScroll) => {
        activeIndex = (index + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => {
          slide.setAttribute('aria-hidden', slideIndex === activeIndex ? 'false' : 'true');
        });
        thumbnails.forEach((thumbnail, thumbnailIndex) => {
          const isActive = thumbnailIndex === activeIndex;
          thumbnail.classList.toggle('is-active', isActive);
          thumbnail.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
        if (shouldScroll) {
          track.scrollTo({ left: slides[activeIndex].offsetLeft, behavior: 'smooth' });
        }
      };

      const getClosestIndex = () => {
        const trackStart = track.getBoundingClientRect().left;
        let closestIndex = 0;
        let closestDistance = Number.POSITIVE_INFINITY;
        slides.forEach((slide, slideIndex) => {
          const distance = Math.abs(slide.getBoundingClientRect().left - trackStart);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = slideIndex;
          }
        });
        return closestIndex;
      };

      previous?.addEventListener('click', () => setActive(activeIndex - 1, true));
      next?.addEventListener('click', () => setActive(activeIndex + 1, true));
      thumbnails.forEach((thumbnail) => {
        thumbnail.addEventListener('click', () => setActive(Number(thumbnail.dataset.gaCarouselThumbnail), true));
      });
      viewport?.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          setActive(activeIndex - 1, true);
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          setActive(activeIndex + 1, true);
        }
        if (event.key === 'Home') {
          event.preventDefault();
          setActive(0, true);
        }
        if (event.key === 'End') {
          event.preventDefault();
          setActive(slides.length - 1, true);
        }
      });
      track.addEventListener('scroll', () => {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(() => setActive(getClosestIndex(), false), 80);
      }, { passive: true });

      setActive(0, false);
    });

    initializeCarousels(document);
    document.addEventListener('shopify:section:load', (event) => initializeCarousels(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
